<template>
  <div>
    <div class="col-md-6 am-addOn-setUp ">
      <div class="col-xs-12 am-addOn-setUp-title-bar am-main-top-box">
        <div><span class="am-addOn-setUp-title am-main-top-box-title"><strong>Apply New Addon</strong></span></div>
        <div class="am-top-icon"> <a @click="goBack">
          <svg-icon class="am-glyphicon-medium am-glyphicon-white" icon="back" title="Back To Back Office Menu"></svg-icon>

        </a></div>
      </div>

      <div class="col-xs-12" style="background-color:#FFFFFF; padding:15px">
        <div class="row">
          <div class="col-xs-4">
            <div class="input-group">
              <div class="input-group-addon input-xs">Search</div>
              <input type="text" class="form-control input-xs" v-model="filterCriteria">
            </div>
          </div>
        </div>

        <table class="table table-hover table-striped table-condensed am-addOn-table">
          <thead>
          <tr>
            <th @click="sort('name')">Name<span><img v-if="sortData.currentSort === 'name'" :src="sorterArrow"></span></th>
            <th @click="sort('cost')">Price<span><img v-if="sortData.currentSort === 'cost'" :src="sorterArrow"></span></th>
            <th @click="sort('bill_type')">Billing Type<span><img v-if="sortData.currentSort === 'bill_type'" :src="sorterArrow"></span></th>
            <th @click="sort('lite_switch')">Include Level<span><img v-if="sortData.currentSort === 'lite_switch'" :src="sorterArrow"></span></th>
            <th @click="sort('isCommissionable')">Commissionable<span><img v-if="sortData.currentSort === 'isCommissionable'" :src="sorterArrow"></span></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="addOn in addOnList" @click="editAddOnPopUp(addOn)" style="cursor: pointer;">
            <td>{{addOn.name}}</td>
            <td>
              <span>${{addOn.cost}}</span>
            </td>
            <td>{{addOn.bill_type}}</td>
            <td>{{translateName(addOn.lite_switch)}}</td>
            <td>{{translateCommissionable(addOn.isCommissionable)}}</td>
          </tr>
          </tbody>
        </table>
        <div class="am-addOn-setUp-pagination col-xs-12 text-center" v-show="allAddOns.length > pageSize">
          <pagination :allData="filteredAddOns" :pageSize="pageSize" :sortData="sortData" @setPageData="setPageData"></pagination>
        </div>
      </div>
      <div class=" col-xs-12 am-blue-footer am-main-bottom-box"></div>
    </div>
    <modal name="editAddOn" classes="am-vue-modal" :clickToClose="true" :pivotY="0.5" :adaptive="false" height="auto" width="500px">
      <add-on-edit :edit-add-on="editRow"></add-on-edit>
    </modal>
  </div>
</template>

<script>
import api from './../http'
import pagination from '@/components/pagination/pagination.vue'
import AddOnEdit from './AddOnEdit'
import sort from '@/mixins/tableSorter'

export default {
  data: function () {
    return {
      name: 'AddOnSetUp',
      pageSize: 15,
      addOnList: [],
      filterCriteria: '',
      editRow: {
        type: Object,
        default: []
      }
    }
  },

  mixins: [sort],

  computed: {
    filteredAddOns () {
      if (this.filterCriteria.length === 0) {
        return this.allAddOns
      }
      return this.filterAddOns(this.allAddOns, this.filterCriteria)
    }
  },

  components: {
    AddOnEdit,
    pagination,
  },

  asyncComputed: {
    allAddOns: {
      get () {
        return api.makeRequest('backoffice/addOnsList').then(
          (data) => {
            return data.data.data
          }
        )
      },
      default: []
    }
  },

  methods: {
    setPageData (data) {
      this.addOnList = data
    },

    filterAddOns (allAddOns, filterCriteria) {
      filterCriteria = filterCriteria.toLowerCase()
      return allAddOns.filter(function (addOn) {
        return addOn.name.toLowerCase().indexOf(filterCriteria) > -1
      })
    },

    translateName (addOn) {
      if (addOn === 'undefined') {
        return 'Unknown'
      }
      switch (addOn) {
        case 0:
          return 'Gold'
        case 1:
          return 'Lite'
        case 2:
          return 'Platinum'
        case 3:
          return 'Diamond'
        case 4:
          return 'Enterprise'
        case 999:
          return 'None'
        case 100:
          return 'Carrier'
        default:
          return 'Unknown'
      }
    },

    translateCommissionable (commissionable) {
      switch (commissionable) {
        case 0:
          return 'No'
        case 1:
          return 'Yes'
      }
    },

    goBack () {
      window.history.go(-2)
    },

    editAddOnPopUp (row) {
      this.editRow = row
      this.$modal.show('editAddOn')
    }
  }
}
</script>

<style scoped>
  .am-addOn-table thead {
    background-color: #444444;
    color: white;
  }
  .am-addOn-table th {
    cursor: pointer;
  }
  .am-addOn-setUp {
    margin-top: 20px;
  }

  .am-blue-footer{
    height: 35px;
  }

  .am-addOn-setUp-title-bar {
    height: 37px;
  }

  .am-addOn-setUp-title {
    font-size: 14px;
    color: #FDFEFE;
    float: left;
    padding: 7px 10px 0px 5px;
  }

  .am-top-icon {
    float: right;
    padding: 8px;
  }

  .am-addOn-setUp-pagination {
    margin: 8px 8px 0 8px;
    display: inline-block;
    padding-left: 0;
  }
</style>

<style>
  .am-vue-modal {
    background-color: white;
    text-align: left;
    border-radius: 0;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
    padding: 0;
  }
</style>
